import { Plus, UserPlus } from 'lucide-react';

type Props = {
  onNewOrder: () => void;
  onCustomer: () => void;
};

export function LargeActionButtons({ onNewOrder, onCustomer }: Props) {
  return (
    <section className="grid grid-cols-2 gap-3" aria-label="Order actions">
      <button
        type="button"
        onClick={onNewOrder}
        className="flex min-h-[72px] items-center justify-center gap-2 rounded-2xl bg-[#00549C] px-3 text-base font-extrabold text-white shadow-sm transition hover:bg-[#003B70] active:scale-[0.98]"
      >
        <Plus size={22} aria-hidden="true" /> New Order
      </button>
      <button
        type="button"
        onClick={onCustomer}
        className="flex min-h-[72px] items-center justify-center gap-2 rounded-2xl border border-[#9EC6E9] bg-white px-3 text-base font-extrabold text-[#00549C] shadow-sm transition hover:bg-[#DCEEFF] active:scale-[0.98]"
      >
        <UserPlus size={22} aria-hidden="true" /> Add Customer
      </button>
    </section>
  );
}
